import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ManageServer.css";

const ManageServer = () => {
  const navigate = useNavigate();
  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchServers = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/servers/list");
      const rawData = res.data?.data || res.data || [];
      const data = Array.isArray(rawData) ? rawData : [];
      setServers(data);
    } catch (err) {
      console.error("Error fetching servers cluster repository:", err);
      setServers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServers();
    // প্রতি 30 সেকেন্ডে auto-refresh (heartbeat live দেখতে)
    const t = setInterval(fetchServers, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="manage-server-container">

      {/* HEADER */}
      <div className="manage-server-header" style={{ marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <h2 style={{ margin: 0, fontSize: "24px", color: "#1e293b", fontWeight: "800" }}>Manage Servers</h2>
          <p style={{ margin: "4px 0 0 0", color: "#64748b", fontSize: "14px" }}>
            Live cluster telemetry from client heartbeats (auto-refresh every 30s).
          </p>
        </div>
        <button
          onClick={fetchServers}
          style={{ padding: "8px 16px", borderRadius: "6px", border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer", fontWeight: "600", fontSize: "13px", color: "#334155" }}
        >
          ↻ Refresh
        </button>
      </div>

      {loading ? (
        <div className="manage-server-loading" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px", gap: "12px" }}>
          <div className="manage-server-spinner" style={{ width: "30px", height: "30px", border: "3px solid #f3f3f3", borderTop: "3px solid #0f172a", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
          <p style={{ color: "#64748b", fontSize: "14px" }}>Syncing Cluster Live Parameters...</p>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      ) : (
        <>
          <div className="manage-server-table-wrapper" style={{ background: "#fff", borderRadius: "8px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
            <table className="manage-server-table" style={{ width: "100%", borderCollapse: "collapse", textAlign: "left" }}>
              <thead>
                <tr style={{ background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                  <th style={{ padding: "12px 16px", width: "70px", color: "#475569", fontWeight: "700" }}>ID</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>Server / Client Node</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>IP Address</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>CPU / RAM / Disk</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>Uptime</th>
                  <th style={{ padding: "12px 16px", color: "#475569", fontWeight: "700" }}>Status</th>
                  <th style={{ padding: "12px 16px", textAlign: "center", width: "120px", color: "#475569", fontWeight: "700" }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {servers.length > 0 ? (
                  servers.map((s) => (
                    <tr key={s.id} style={{ borderBottom: "1px solid #f1f5f9" }}>

                      <td style={{ padding: "16px", fontFamily: "monospace", color: "#64748b", fontWeight: "600" }}>
                        #{s.id}
                      </td>

                      <td style={{ padding: "16px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                          <span style={{ fontWeight: "600", color: "#1e293b", fontSize: "15px" }}>
                            {s.server_name || s.hostname || "Unnamed Node"}
                          </span>
                          <span style={{ fontFamily: "monospace", fontSize: "11px", color: "#94a3b8" }}>
                            {s.os_info ? `${s.os_info} · ` : ""}UUID: {s.uuid ? `${String(s.uuid).substring(0, 18)}...` : "N/A"}
                          </span>
                        </div>
                      </td>

                      {/* IP: lan_ip প্রাইমারি, public_ip সেকেন্ডারি */}
                      <td style={{ padding: "16px", fontFamily: "monospace", color: "#334155", fontSize: "13px" }}>
                        <div>{s.lan_ip || "—"}</div>
                        {s.public_ip && (
                          <div style={{ fontSize: "11px", color: "#94a3b8" }}>pub: {s.public_ip}</div>
                        )}
                      </td>

                      {/* CPU / RAM / Disk */}
                      <td style={{ padding: "16px" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "3px", fontSize: "13px" }}>
                          <div>
                            <span style={{ color: "#64748b" }}>CPU: </span>
                            <span style={{ fontFamily: "monospace", fontWeight: "600", color: parseFloat(s.cpu_usage) > 80 ? "#ef4444" : "#0f172a" }}>
                              {s.cpu_usage ?? 0}%
                            </span>
                          </div>
                          <div>
                            <span style={{ color: "#64748b" }}>RAM: </span>
                            <span style={{ fontFamily: "monospace", fontWeight: "600", color: parseFloat(s.ram_usage) > 85 ? "#ef4444" : "#0f172a" }}>
                              {s.ram_usage ?? 0}%
                            </span>
                          </div>
                          <div>
                            <span style={{ color: "#64748b" }}>Disk: </span>
                            <span style={{ fontFamily: "monospace", fontWeight: "600", color: parseFloat(s.disk_usage) > 90 ? "#ef4444" : "#0f172a" }}>
                              {s.disk_usage ?? 0}%
                            </span>
                          </div>
                        </div>
                      </td>

                      <td style={{ padding: "16px", fontSize: "13px", color: "#475569", fontFamily: "monospace" }}>
                        {s.uptime || "N/A"}
                      </td>

                      <td style={{ padding: "16px" }}>
                        <span
                          style={{
                            display: "inline-block", padding: "4px 8px", borderRadius: "4px",
                            fontSize: "12px", fontWeight: "bold", textTransform: "uppercase",
                            background: s.status === "active" ? "#dcfce7" : "#fee2e2",
                            color: s.status === "active" ? "#15803d" : "#b91c1c"
                          }}
                        >
                          {s.status === "active" ? "online" : "offline"}
                        </span>
                      </td>

                      <td style={{ padding: "16px", textAlign: "center" }}>
                        <button
                          onClick={() => navigate(`/servers/edit/${s.id}`)}
                          style={{ padding: "6px 14px", borderRadius: "4px", border: "1px solid #cbd5e1", background: "#fff", cursor: "pointer", fontWeight: "600", fontSize: "13px", color: "#1e293b" }}
                          onMouseOver={(e) => (e.target.style.background = "#f8fafc")}
                          onMouseOut={(e) => (e.target.style.background = "#fff")}
                        >
                          Edit Node
                        </button>
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center", padding: "32px", color: "#64748b" }}>
                      ⚠️ No enrolled server nodes reporting heartbeats yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "24px" }}>
            <button onClick={() => navigate("/")} className="manage-server-back-btn">
              ← Back to Dashboard
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ManageServer;